import { Injectable, Inject } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';

import { LanguageEvents } from './events';
import { ENV_CONFIG } from 'src/app/core/injection.token';

@Injectable()
export class LanguageAPIService {
  public constructor(
    @Inject(ApiService) private _apiService: ApiService,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvData
  ) {}

  private readonly controller = 'language';

  public getTenantLanguages() {
    const request = 'getTenantLanguages';
    const url = this._apiService.buildUrl(this._envConfig.TENANT_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.get<app.models.Language[]>(url);
  }

  public getLanguage(languageId: string) {
    const request = 'getLanguage';
    const url = this._apiService.buildUrl(this._envConfig.TENANT_BACKEND_APISYNC_URL, this.controller, request);
    const data = { languageId: languageId };

    return this._apiService.get<app.models.Language>(url, data);
  }

  public getTranslationFromAssetsByLanguageCode(languageCode: string) {
    return this._apiService.get<string>(`/assets/i18n/${languageCode}.json`);
  }

  public saveTranslationFile(file: any) {
    const request = 'saveTranslationFile';
    const url = this._apiService.buildUrl(this._envConfig.TENANT_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.postAsync<app.models.ServerResponseModel>(url, file, [LanguageEvents.LanguageFileSaved]);
  }
}
